import {ChangeDetectionStrategy, Component} from '@angular/core';
import {Observable} from 'rxjs';
import {distinctUntilChanged, map, takeUntil, tap} from 'rxjs/operators';
import {destroy$} from '../../../components/destroyable';
import {UserStatus} from '../../../enums/user-status';
import {UserService} from '../../../services/user.service';
import {ONBOARDING_STATUS_DICT, OnboardingStatusDictRecord} from '../display-onboarding-status';

@Component({
    templateUrl: './onboarding-menu-item.component.html',
    styleUrls: ['./onboarding-menu-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OnboardingMenuItemComponent {

    public readonly onboardingStatus: Observable<UserStatus> = this.createOnboardingStatusStream();

    public displayOnboardingStatus: OnboardingStatusDictRecord;

    public readonly destroy$ = destroy$();

    constructor(
        private userService: UserService
    ) {
        this.onboardingStatus.pipe(
            tap(onboardingStatus => this.displayOnboardingStatus = ONBOARDING_STATUS_DICT[onboardingStatus]),
            takeUntil(this.destroy$)
        ).subscribe();
    }

    private createOnboardingStatusStream(): Observable<UserStatus> {
        return this.userService.user$.pipe(
            map(user => user && user.status),
            distinctUntilChanged()
        );
    }

}
